import { Form_ResetButton } from '../../components/form/buttons/Form_ResetButton';
import { Form_SubmitButton } from '../../components/form/buttons/Form_SubmitButton';

export const Buttons = {
    Reset: Form_ResetButton,
    Submit: Form_SubmitButton,
};
